module.exports = __webpack_public_path__ + "img/phones-sm@2x.fa6dd181.png";